import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Flame, X, ChevronRight } from 'lucide-react';

const daysTo = (date) => Math.max(0, Math.ceil((new Date(`${date}T20:00:00+02:00`).getTime() - Date.now()) / 86400000));

const MobileCountdownBar = () => {
  const [settings, setSettings] = useState(null);
  const [dismissed, setDismissed] = useState(() => sessionStorage.getItem('tp_cd_bar_dismissed') === '1');
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/site-content/home-settings`)
      .then(r => r.json())
      .then(setSettings)
      .catch(() => {});
  }, []);

  if (dismissed || !settings?.countdown_enabled || !settings.countdown_date || location.pathname.startsWith('/admin')) return null;

  const days = daysTo(settings.countdown_date);
  const dismiss = (e) => {
    e.stopPropagation();
    sessionStorage.setItem('tp_cd_bar_dismissed', '1');
    setDismissed(true);
  };

  return (
    <div
      role="button"
      tabIndex={0}
      data-testid="mobile-countdown-bar"
      onClick={() => navigate('/?iscrizione=1')}
      onKeyDown={(e) => { if (e.key === 'Enter') navigate('/?iscrizione=1'); }}
      className="sm:hidden fixed bottom-0 left-0 right-0 z-40 flex items-center gap-3 px-4 py-2.5 border-t border-red-500/50 cursor-pointer active:scale-[0.99] transition-transform"
      style={{ backgroundColor: 'rgba(10,10,10,0.94)', backdropFilter: 'blur(10px)', paddingBottom: 'calc(0.625rem + env(safe-area-inset-bottom))' }}
    >
      <Flame size={20} className="text-red-500 shrink-0 animate-pulse" />
      <div className="flex-1 min-w-0 leading-tight">
        <p className="text-white font-bold text-sm truncate" style={{ fontFamily: 'Oswald, sans-serif', letterSpacing: '0.5px' }} data-testid="mobile-countdown-days">
          <span className="text-red-500 text-base">{days}</span> {days === 1 ? 'GIORNO' : 'GIORNI'} ALLA FINALE
        </p>
        <p className="text-gray-400 text-[11px] truncate">Tocca per iscriverti al torneo</p>
      </div>
      <span className="inline-flex items-center gap-0.5 text-[11px] font-bold text-white px-3 py-1.5 rounded-full shrink-0" style={{ backgroundColor: 'var(--tp-red)', fontFamily: 'Oswald, sans-serif' }}>
        ISCRIVITI <ChevronRight size={13} />
      </span>
      <button type="button" onClick={dismiss} aria-label="Chiudi" data-testid="mobile-countdown-close" className="p-1 text-gray-500 hover:text-white shrink-0">
        <X size={16} />
      </button>
    </div>
  );
};

export default MobileCountdownBar;
